import { QueryClient } from '@tanstack/react-query'

import { isApiError } from './api'

/**
 * 全局 QueryClient 默认档。
 * - 4xx 不重试(请求本身有问题,重试只是浪费一轮);5xx / 网络失败重试 1 次。
 * - staleTime 30s:控制台场景切页频繁,避免每次回列表都打一遍接口。
 * - 写操作(mutation)一律不重试,避免重复提交。
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && error.isClientError) return false
          return failureCount < 1
        },
      },
      mutations: {
        retry: false,
      },
    },
  })
}

export const queryClient = createQueryClient()
